<template>
    <div class="HeroVideo" :class="[{ 'HeroVideo--home': homepage }, usingVideo ? 'HeroVideo--video' : 'HeroVideo--image']">
        <div class="HeroVideo__overlay"></div>

        <video
            v-if="usingVideo"
            autoplay
            muted
            playsinline
            loop 
            class="HeroVideo__video"
        >
            <source
                :src="videoData" 
                type="video/mp4"
            >
        </video>

        <div 
            v-else
            class="HeroVideo__image"
        >
            <img :srcset="image" />
        </div>
        
        <div class="HeroVideo__container">
            <div class="container">
                <BaseHeading
                    v-if="showHeading"
                    :preheading="preheading"
                    :heading="heading"
                    tag="h1"
                    class="text--white"
                />
                <HeroSearch 
                    v-if="homepage"
                    :search-placeholder="searchPlaceholder" 
                />
            </div> 
        </div>
    </div>
</template>

<script>
import HeroSearch from './HeroSearch.vue';
export default {
    name: 'HeroVideo',
    components: {
        HeroSearch
    },
    data: () => ({
        allowMotion: true
    }),
    props: {
        videoData: {
            type: String,
            required: true
        },
        showHeading: {
            type: Boolean,
            default: true
        },
        preheading: {
            type: String,
            default: null
        },
        heading: {
            type: String,
            default: null
        },
        image: {
            type: String,
            required: true
        },
        searchPlaceholder: {
            type: String,
            default: 'Search'
        },
        homepage: {
            type: Boolean,
            default: false
        }
    },

    created() {
        // Detect users OS setting for reduced motion
        const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (motionQuery.matches) this.allowMotion = false;
    },

    computed: {
        usingVideo() {
            return this.videoData && this.allowMotion;
        }
    }
}
</script>

<style lang="scss" scoped>

    .HeroVideo {
        position: relative;
        height: 100vh;

        @include media-query(portable) {
            height: 80vh;
        }

        @include media-query(tiny) {
            height: 100vh;
            max-height: 700px;
        }

        &.HeroVideo--image:not(.HeroVideo--home) {
            height: calc(100vh - 114px); // Header height

            @include media-query(lap) {
                height: calc(100vh - 88px);
            }

            @include media-query(palm) {
                height: calc(100vh - 72px);
                max-height: auto;
            }
        }
    }

    .HeroVideo__overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            180deg, rgba(0,0,0,0.75) 0%,
            rgba(13,13,13,0.1) 20%,
            rgba(4,4,4,0) 100%
        );
        z-index: 1;
    }

    video {
        object-fit: cover;
        object-position: center;
        width: 100%;
        height: 100%;
        z-index: 1;
    }

    .HeroVideo__image {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .HeroVideo__container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding: 2rem 1.5rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        z-index: 2;

        .HeroVideo--home & {
            align-items: center;
            justify-content: center;
        }

        .container {
            width: 100%;

            .HeroVideo--home & {
                display: contents;
            }
        }
    }

    .BaseHeading {
        max-width: 700px;
        position: relative;
        
        .HeroVideo--home & {
            max-width: 550px;
            margin-bottom: getSpacing(medium);
            text-align: center;
        }
    }
</style>
